export default __webpack_public_path__ + "static/media/print.icon.cf4a0594.svg";